import React from "react";

export default function Error({ message }) {
  return (
    <p className="bg-red1 rounded font-roboto font-normal px-3 py-2 text-xs">
      {message}
    </p>
  );
}
